/* Kirane — le canapé CUSTOM.
   Un petit + sur l'assise invite à poser une housse ; on la choisit dans le panneau,
   on y règle sa taille, puis on la pose. Toucher une housse posée rouvre sa fiche.
   S'appuie sur window.trioConfig (housses détourées, intérieurs, offre, libellés). */
(function () {
  'use strict';

  const cfg = window.trioConfig || {};
  const t = (k, f) => (cfg.strings && cfg.strings[k]) || f;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (cents) => {
    const fmt = cfg.moneyFormat || '{{amount}} €';
    const v = cents / 100;
    const comma = v.toFixed(2).replace('.', ',');
    const noDec = Math.round(v).toString();
    const smart = Number.isInteger(v) ? noDec : comma;
    return fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, smart)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/, smart)
      .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/, smart)
      .replace(/\{\{\s*amount\s*\}\}/, Number.isInteger(v) ? noDec : v.toFixed(2));
  };
  const img = (src, w) => {
    if (!src) return '';
    const clean = src.replace(/(&|\?)width=\d+/, '');
    return clean + (clean.includes('?') ? '&' : '?') + 'width=' + (w || 400);
  };
  const sizeKey = (str) => {
    if (!str) return null;
    const s = String(str).toLowerCase();
    if (/rond/.test(s)) return 'rond';
    const m = s.match(/(\d{2,3})\s*(?:cm)?\s*x\s*(\d{2,3})/);
    return m ? m[1] + 'x' + m[2] : null;
  };
  const sizeLabel = (k) => (!k ? '' : k === 'rond' ? t('round', 'rond') : k.replace('x', ' × ') + ' cm');
  const shortTitle = (title) => String(title)
    .replace(/^Housses? de Coussins?\s*(Rond\s*)?(-\s*)?/i, (m, r) => (r ? 'rond · ' : ''))
    .replace(/\s*-\s*\d{2,3}\s*x\s*\d{2,3}\s*cm$/i, '').replace(/\s*-\s*XL.*$/i, ' XL').trim();
  /* la surface du coussin, en cm² : sert à proposer la plus grande taille d'abord */
  const area = (k) => {
    if (!k) return 0;
    if (k === 'rond') return 45 * 45;
    const m = String(k).split('x').map(Number);
    return m.length === 2 && m[0] && m[1] ? m[0] * m[1] : 0;
  };

  const normalise = (p) => {
    const variants = (p.variants || []).map((v) => ({
      id: v.id, title: v.title,
      price: typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price,
      available: v.available !== false,
      size: sizeKey(v.title) || sizeKey(p.title)
    }));
    return {
      handle: p.handle, title: p.title, short: p.short || shortTitle(p.title),
      url: p.url || (cfg.productsUrl || '/products/') + p.handle,
      image: p.image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '',
      tags: (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map((x) => x.trim())).filter(Boolean),
      variants: variants, hasOptions: variants.length > 1,
      minPrice: Math.min.apply(null, variants.map((v) => v.price))
    };
  };
  const firstAvailable = (p) => p.variants.find((v) => v.available) || p.variants[0];
  /* la plus grande taille disponible, en évitant celles déjà posées :
     un Lotus Café arrive donc en 40x60, pas en 45x45 */
  const bestVariant = (p, used) => {
    const big = p.variants.slice().sort((a, b) => area(b.size) - area(a.size));
    return big.find((v) => v.available && (used || []).indexOf(v.size) === -1)
      || big.find((v) => v.available) || firstAvailable(p);
  };
  const insertFor = (key) => {
    const ins = cfg.inserts;
    if (!ins || !key) return null;
    if (key === 'rond') return ins.round;
    if (key === '110x55' || key === '55x110') return ins.xl;
    const alt = key.split('x').reverse().join('x');
    return (ins.square || []).find((v) => { const k = sizeKey(v.size); return k === key || k === alt; }) || null;
  };

  const price = (slots) => {
    const mode = cfg.offer || 'none';
    const nFree = mode === 'third_free' ? Math.min(Math.floor(slots.length / 3), 2) : 0;
    const free = slots.map((s, i) => ({ s: s, i: i })).sort((a, b) => a.s.variant.price - b.s.variant.price)
      .slice(0, nFree).map((x) => x.i);
    return { n: slots.length, free: free, offer: mode !== 'none' };
  };
  const totalOf = (slots, pr, insertsOn) => {
    let sum = 0;
    slots.forEach((s, i) => {
      if (pr.free.indexOf(i) === -1) sum += s.variant.price;
      const ins = insertFor(s.variant.size);
      if (insertsOn && ins && ins.available !== false) sum += ins.price;
    });
    return sum;
  };

  const addToCart = (items) => {
    const useDrawer = cfg.cartDrawer && document.getElementById('Cart-Drawer');
    const body = { items: items };
    if (useDrawer) { body.sections = 'cart-drawer,cart-bubble'; body.sections_url = window.location.pathname; }
    return fetch(cfg.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then((r) => r.json()).then((res) => {
      if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'Erreur');
      if (useDrawer && res.sections) {
        const put = (id, sel, html) => {
          const root = document.getElementById(id); if (!root || !html) return;
          const target = root.querySelector(sel) || root;
          const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
          if (parsed) target.innerHTML = parsed.innerHTML;
        };
        put('Cart-Drawer', '.cart-drawer', res.sections['cart-drawer']);
        put('cart-drawer-toggle', '.thb-item-count', res.sections['cart-bubble']);
        const drawer = document.getElementById('Cart-Drawer');
        if (typeof OverlayManager !== 'undefined') OverlayManager.open(drawer); else drawer.classList.add('active');
        if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open');
      } else {
        window.location.href = cfg.cartUrl;
      }
      return res;
    });
  };

  /* ---- verrou de défilement (iOS : sans ça la page glisse derrière le panneau) ---- */
  let locks = 0, lockY = 0;
  const lock = () => {
    if (++locks > 1) return;
    lockY = window.scrollY;
    const bar = window.innerWidth - document.documentElement.clientWidth;
    if (bar > 0) document.body.style.paddingRight = bar + 'px';
    document.body.style.position = 'fixed';
    document.body.style.top = -lockY + 'px';
    document.body.style.width = '100%';
    document.body.classList.add('trio-sheet-open');
  };
  const unlock = () => {
    if (--locks > 0) return;
    locks = 0;
    document.body.classList.remove('trio-sheet-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.paddingRight = '';
    window.scrollTo(0, lockY);
  };

  /* ---- le canapé, à l'échelle (1 unité = 1 cm) ---- */
  const ARM = 17, SEAT_TOP = 80, SEAT_BOT = 103, BACK_TOP = 36, LEG_H = 15, CUSHION_BASE = 84, ARM_RISE = 25;
  const TILT = [-2.4, 1.6, -1.6, 2.4, -1, 1.8, -1.8, 1];
  /* la gamme de teintes du curseur : des neutres d'abord, puis les couleurs */
  const RANGE = ['#F2EDE4', '#DED4C6', '#C4B7A6', '#A88F79', '#8C7767', '#6F6B66', '#C9C4BB', '#B7C0B2', '#8FA08E', '#6C7A8C', '#C89C88', '#A55E46'];
  const SOFA_DEFAULT = '#DED4C6';
  const hex2rgb = (h) => { h = String(h).replace('#', ''); if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; const n = parseInt(h, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; };
  const rgb2hex = (c) => '#' + c.map((x) => Math.max(0, Math.min(255, Math.round(x))).toString(16).padStart(2, '0')).join('');
  const mix = (h, target, amt) => { const a = hex2rgb(h), b = hex2rgb(target); return rgb2hex([0, 1, 2].map((i) => a[i] + (b[i] - a[i]) * amt)); };
  const tint = (h, a) => mix(h, '#ffffff', a);
  const shade = (h, a) => mix(h, '#2A2118', a);
  const isHex = (v) => /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(String(v || ''));
  /* la teinte continue, lue sur le curseur multicolore */
  const rangeAt = (p) => {
    const u = Math.max(0, Math.min(1, p)) * (RANGE.length - 1);
    const i = Math.min(RANGE.length - 2, Math.floor(u));
    return mix(RANGE[i], RANGE[i + 1], u - i);
  };
  const tones = (base) => { const b = isHex(base) ? base : SOFA_DEFAULT; return { back: b, seat: tint(b, 0.14), arm: shade(b, 0.05), leg: mix(b, '#3B2E22', 0.62) }; };

  const ART = cfg.cushions || {};
  const ART_BASE = cfg.filesBase || '//cdn.shopify.com/s/files/1/0895/6723/2323/files/';
  const artFor = (handle, size) => {
    if (!handle || !size) return null;
    return ART[handle + '__' + size] || ART[handle + '__' + String(size).split('x').reverse().join('x')] || null;
  };
  const tileFor = (p, size) => {
    const want = size && artFor(p.handle, size);
    if (want) return ART_BASE + want[0] + '?width=340';
    for (let i = 0; i < p.variants.length; i++) {
      const a = artFor(p.handle, p.variants[i].size);
      if (a) return ART_BASE + a[0] + '?width=340';
    }
    return img(p.image, 340);
  };

  const boxOf = (size) => {
    const k = size || '45x45';
    if (k === 'rond') return { w: 45, h: 45, round: true };
    const m = k.split('x').map(Number);
    if (m.length !== 2 || !m[0] || !m[1]) return { w: 45, h: 45 };
    return { w: Math.max(m[0], m[1]), h: Math.min(m[0], m[1]) };
  };
  const layout = (boxes, sofaW) => {
    const n = boxes.length;
    if (!n) return { items: [], over: false };
    const total = boxes.reduce((s, b) => s + b.w, 0);
    let ov = 0;
    if (n > 1) {
      const need = total - (sofaW - 8);
      const small = Math.min.apply(null, boxes.map((b) => b.w));
      const cap = small * (n === 2 ? 0.74 : 0.6);
      ov = need > 0 ? need / (n - 1) : Math.min(7, (total * 0.04) / (n - 1));
      ov = Math.max(0, Math.min(ov, cap));
    }
    const width = total - ov * (n - 1);
    let x = ARM + (sofaW - width) / 2;
    const items = boxes.map((b, i) => { const it = { b: b, i: i, x: x }; x += b.w - ov; return it; });
    return { items: items, over: width > sofaW + ARM };
  };

  const sofaSVG = (uid, slots, sofaW, colour, canAdd) => {
    const T = tones(colour), W = sofaW + 2 * ARM, g = uid + 'g';
    const SEAT_H = SEAT_BOT - SEAT_TOP;
    const boxes = slots.map((s) => { const b = boxOf(s.variant.size); b.slot = s; return b; });
    /* le + prend sa place dans la rangée, là où la prochaine housse se posera */
    if (canAdd) boxes.push({ w: slots.length ? 26 : 44, h: 40, add: true });
    const L = layout(boxes, sofaW);

    let defs =
      '<linearGradient id="' + g + 'b" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0" stop-color="' + tint(T.back, 0.1) + '"></stop>' +
        '<stop offset="1" stop-color="' + shade(T.back, 0.07) + '"></stop></linearGradient>' +
      '<linearGradient id="' + g + 's" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0" stop-color="' + tint(T.seat, 0.07) + '"></stop>' +
        '<stop offset="1" stop-color="' + shade(T.seat, 0.09) + '"></stop></linearGradient>' +
      '<linearGradient id="' + g + 'a" x1="0" y1="0" x2="1" y2="0">' +
        '<stop offset="0" stop-color="' + tint(T.arm, 0.09) + '"></stop>' +
        '<stop offset="1" stop-color="' + shade(T.arm, 0.1) + '"></stop></linearGradient>' +
      '<radialGradient id="' + g + 'o">' +
        '<stop offset="0" stop-color="#2A2118" stop-opacity=".2"></stop>' +
        '<stop offset="1" stop-color="#2A2118" stop-opacity="0"></stop></radialGradient>';

    let plus = '', art = '';
    const front = (it) => (it.b.slot && it.b.slot.front) || 0;
    L.items.slice().sort((a, b) => front(a) - front(b) || b.b.w * b.b.h - a.b.w * a.b.h).forEach((it) => {
      const b = it.b, s = b.slot, y = CUSHION_BASE - b.h;
      const x0 = b.add ? it.x : it.x + (s.dx || 0);
      const x = Math.max(-6, Math.min(W + 6 - b.w, x0));
      const cx = x + b.w / 2, cy = y + b.h / 2;

      if (b.add) {
        /* juste un petit +, sans cadre : il dit où poser la prochaine housse */
        const r = 8.5, c = shade(T.seat, 0.45);
        plus = '<g class="cnp-add" data-add-here role="button" tabindex="0" aria-label="' + esc(t('pick', 'poser une housse')) + '">' +
          '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="#fff" fill-opacity=".5" stroke="' + c + '" stroke-width=".9" opacity=".72"></circle>' +
          '<line x1="' + (cx - 4) + '" y1="' + cy + '" x2="' + (cx + 4) + '" y2="' + cy + '" stroke="' + c + '" stroke-width="1.1" stroke-linecap="round" opacity=".85"></line>' +
          '<line x1="' + cx + '" y1="' + (cy - 4) + '" x2="' + cx + '" y2="' + (cy + 4) + '" stroke="' + c + '" stroke-width="1.1" stroke-linecap="round" opacity=".85"></line>' +
          '<circle cx="' + cx + '" cy="' + cy + '" r="' + (r + 5) + '" fill="#000" fill-opacity="0"></circle>' +
          '</g>';
        return;
      }

      const rx = b.round ? b.w / 2 : 3;
      const open = '<g class="cnp-cushion" data-cushion="' + s.index + '" transform="rotate(' + TILT[it.i % TILT.length] + ' ' + cx + ' ' + cy + ')" role="button" tabindex="0" aria-label="' + esc(s.product.short) + '">';
      const shadow = '<ellipse cx="' + cx + '" cy="' + (CUSHION_BASE - 0.5) + '" rx="' + (b.w * 0.46) + '" ry="2.6" fill="url(#' + g + 'o)" style="pointer-events:none"></ellipse>';
      /* la zone sensible reste le rectangle : le vide autour de la photo ne vole pas le toucher */
      const hit = '<rect x="' + x + '" y="' + y + '" width="' + b.w + '" height="' + b.h + '" rx="' + rx + '" fill="#000" fill-opacity="0"></rect>';
      const a = artFor(s.product.handle, s.variant.size);
      if (a) {
        art += open + shadow + '<image href="' + esc(ART_BASE + a[0]) + '" x="' + (cx - a[1] / 2) + '" y="' + (cy - a[2] / 2) + '" width="' + a[1] + '" height="' + a[2] + '" preserveAspectRatio="none" style="pointer-events:none"></image>' + hit + '</g>';
        return;
      }
      const id = g + 'p' + it.i, w = b.w * 2.5, h = (w * 4) / 3;
      defs += '<pattern id="' + id + '" patternUnits="userSpaceOnUse" x="' + x + '" y="' + y + '" width="' + b.w + '" height="' + b.h + '"><image href="' + esc(img(s.product.image, 700)) + '" x="' + ((b.w - w) / 2) + '" y="' + (b.h / 2 - h * 0.38) + '" width="' + w + '" height="' + h + '" preserveAspectRatio="xMidYMid slice"></image></pattern>';
      art += open + shadow +
        '<rect x="' + x + '" y="' + y + '" width="' + b.w + '" height="' + b.h + '" rx="' + rx + '" fill="url(#' + id + ')"></rect>' + hit + '</g>';
    });

    let seams = '';
    const nb = sofaW > 230 ? 3 : (sofaW > 130 ? 2 : 1);
    for (let k = 1; k < nb; k++) {
      const sx = ARM + (sofaW * k) / nb;
      seams += '<line x1="' + sx + '" y1="' + (BACK_TOP + 5) + '" x2="' + sx + '" y2="' + (SEAT_TOP + 4) + '" stroke="' + shade(T.back, 0.16) + '" stroke-width=".6" opacity=".5"></line>';
    }
    const leg = (lx) => '<path d="M' + lx + ' ' + SEAT_BOT + ' h8 l-1.6 ' + LEG_H + ' h-4.8 z" fill="' + T.leg + '"></path>';

    return '<svg viewBox="-6 24 ' + (W + 12) + ' 102" preserveAspectRatio="xMidYMax meet"><defs>' + defs + '</defs>' +
      '<ellipse cx="' + (W / 2) + '" cy="' + (SEAT_BOT + LEG_H + 1.5) + '" rx="' + (W * 0.47) + '" ry="4.2" fill="url(#' + g + 'o)"></ellipse>' +
      leg(12) + leg(W - 20) + (sofaW > 200 ? leg(W / 2 - 4) : '') +
      '<rect x="' + ARM + '" y="' + BACK_TOP + '" width="' + sofaW + '" height="' + (SEAT_TOP - BACK_TOP + 9) + '" rx="9" fill="url(#' + g + 'b)"></rect>' + seams +
      '<rect x="0" y="' + SEAT_TOP + '" width="' + W + '" height="' + SEAT_H + '" rx="7" fill="url(#' + g + 's)"></rect>' +
      '<line x1="5" y1="' + (SEAT_TOP + SEAT_H * 0.66) + '" x2="' + (W - 5) + '" y2="' + (SEAT_TOP + SEAT_H * 0.66) + '" stroke="' + shade(T.seat, 0.13) + '" stroke-width=".5" opacity=".6"></line>' +
      '<rect x="0" y="' + (SEAT_TOP - ARM_RISE) + '" width="' + ARM + '" height="' + (SEAT_BOT - SEAT_TOP + ARM_RISE) + '" rx="8" fill="url(#' + g + 'a)"></rect>' +
      '<rect x="' + (W - ARM) + '" y="' + (SEAT_TOP - ARM_RISE) + '" width="' + ARM + '" height="' + (SEAT_BOT - SEAT_TOP + ARM_RISE) + '" rx="8" fill="url(#' + g + 'a)"></rect>' +
      art + plus + '</svg>' +
      (L.over ? '<p class="cnp__warn">' + esc(t('too_many', 'ça déborde un peu, élargissez le canapé')) + '</p>' : '');
  };

  /* ---- le panneau : la grille, puis la fiche avec la taille ---- */
  class Sheet {
    constructor() {
      this.el = document.createElement('div');
      this.el.className = 'trio-sheet trio-picker';
      this.el.innerHTML =
        '<div class="trio-sheet__backdrop" data-close></div>' +
        '<div class="trio-sheet__panel" role="dialog" aria-modal="true">' +
          '<div class="trio-sheet__head"><div class="trio-sheet__title" data-title></div>' +
          '<button type="button" class="trio-sheet__close" data-close aria-label="' + esc(t('close', 'fermer')) + '">×</button></div>' +
          '<div class="trio-sheet__filters" data-filters></div>' +
          '<div class="trio-sheet__scroll"><div class="trio-grid" data-grid></div><div data-detail></div></div>' +
        '</div>';
      document.body.appendChild(this.el);
      this.el.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) this.close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.open) this.close(); });
      this.title = this.el.querySelector('[data-title]');
      this.filters = this.el.querySelector('[data-filters]');
      this.grid = this.el.querySelector('[data-grid]');
      this.detail = this.el.querySelector('[data-detail]');
      this.scroll = this.el.querySelector('.trio-sheet__scroll');
      this.filter = 'all';
    }
    show() { if (this.open) return; this.open = true; this.el.classList.add('is-open'); lock(); }
    close() { if (!this.open) return; this.open = false; this.el.classList.remove('is-open'); unlock(); }
    families() { return cfg.families || [{ key: 'all', label: t('filter_all', 'toutes'), tags: [] }]; }

    /* étape 1 : la grille */
    pick(products, used, onPose) {
      this.title.textContent = t('pick', 'choisir une housse');
      this.detail.hidden = true; this.grid.hidden = false; this.filters.hidden = false;
      this.scroll.scrollTop = 0;
      const drawFilters = () => {
        this.filters.innerHTML = this.families().map((f) => '<button type="button" class="trio-chip' + (f.key === this.filter ? ' is-on' : '') + '" data-f="' + f.key + '">' + esc(f.label) + '</button>').join('');
        this.filters.querySelectorAll('[data-f]').forEach((b) => b.addEventListener('click', () => { this.filter = b.dataset.f; drawFilters(); drawGrid(); this.scroll.scrollTop = 0; }));
      };
      const drawGrid = () => {
        const fam = this.families().find((f) => f.key === this.filter);
        const list = products.filter((p) => {
          if (!fam) return true;
          if (fam.sizes && fam.sizes.length) return p.variants.some((v) => fam.sizes.indexOf(v.size) !== -1);
          if (!fam.tags.length) return true;
          return p.tags.some((tg) => fam.tags.indexOf(String(tg).toLowerCase()) !== -1);
        });
        this.grid.innerHTML = list.map((p) => {
          const live = p.variants.some((v) => v.available);
          return '<button type="button" class="trio-tile' + (live ? '' : ' is-off') + '" data-h="' + esc(p.handle) + '">' +
            '<span class="trio-tile__img"><img src="' + esc(tileFor(p)) + '" alt="" loading="lazy">' +
            (live ? '' : '<span class="trio-tile__badge trio-tile__badge--off">' + esc(t('soldout', 'épuisée')) + '</span>') + '</span>' +
            '<span class="trio-tile__name">' + esc(p.short) + '</span></button>';
        }).join('') || '<p class="trio-empty">' + esc(t('none', 'rien dans cette famille pour le moment')) + '</p>';
        this.grid.querySelectorAll('[data-h]').forEach((b) => b.addEventListener('click', () => {
          const p = products.find((x) => x.handle === b.dataset.h);
          if (p) this.detailOf(p, bestVariant(p, used), onPose, () => this.pick(products, used, onPose));
        }));
      };
      drawFilters(); drawGrid();
      this.show();
    }

    /* étape 2 : la housse, sa taille, et on la pose */
    detailOf(p, variant, onPose, back) {
      let v = variant;
      this.title.textContent = p.short;
      this.grid.hidden = true; this.filters.hidden = true; this.detail.hidden = false;
      this.scroll.scrollTop = 0;
      const draw = () => {
        this.detail.innerHTML = '<div class="cnp-detail">' +
          '<img class="cnp-detail__img" src="' + esc(tileFor(p, v.size)) + '" alt="">' +
          '<p class="cnp-detail__name">' + esc(p.short) + '</p>' +
          '<p class="cnp-detail__price">' + esc(money(v.price)) + '</p>' +
          (p.hasOptions
            ? '<p class="cnp-detail__label">' + esc(t('size', 'taille')) + '</p><div class="trio-seg trio-seg--lg" role="radiogroup">' +
              p.variants.map((x) => '<button type="button" class="trio-seg__btn' + (x.id === v.id ? ' is-on' : '') + (x.available ? '' : ' is-off') + '" data-v="' + x.id + '">' + esc(sizeLabel(x.size) || x.title) + '</button>').join('') + '</div>'
            : '<p class="cnp-detail__label">' + esc(sizeLabel(v.size)) + '</p>') +
          '<div class="cnp-detail__acts">' +
            '<button type="button" class="trio-btn" data-pose ' + (v.available ? '' : 'disabled') + '>' +
              esc(v.available ? t('pose', 'poser sur le canapé') : t('soldout', 'épuisée')) + '</button>' +
            (back ? '<button type="button" class="trio-textlink" data-back>' + esc(t('back', 'retour')) + '</button>' : '') +
            (this.onRemove ? '<button type="button" class="trio-textlink" data-remove>' + esc(t('remove', 'retirer')) + '</button>' : '') +
          '</div></div>';
        this.detail.querySelectorAll('[data-v]').forEach((b) => b.addEventListener('click', () => {
          v = p.variants.find((x) => String(x.id) === b.dataset.v); draw();
        }));
        this.detail.querySelector('[data-pose]').addEventListener('click', () => { onPose(p, v); this.close(); });
        const bk = this.detail.querySelector('[data-back]');
        if (bk) bk.addEventListener('click', () => back());
        const rm = this.detail.querySelector('[data-remove]');
        if (rm) rm.addEventListener('click', () => { this.onRemove(); this.close(); });
      };
      draw();
      this.show();
    }
  }
  let sheet = null;
  const getSheet = () => (sheet = sheet || new Sheet());

  /* ---- l'atelier ---- */
  const MAX_SLOTS = 8;

  class CanapeStudio extends HTMLElement {
    connectedCallback() {
      this.uid = 'cs' + Math.random().toString(36).slice(2, 7);
      this.products = [];
      this.slots = [];
      this.frontSeq = 0;
      this.insertsOn = this.dataset.insertsDefault === 'true';

      this.stage = this.querySelector('[data-sofa]');
      this.note = this.querySelector('[data-note]');
      this.btn = this.querySelector('[data-add]');
      this.err = this.querySelector('[data-error]');
      this.range = this.querySelector('[data-range]');
      this.value = this.querySelector('[data-value]');
      this.hue = this.querySelector('[data-hue]');
      this.say = this.querySelector('[data-say]');

      const min = parseInt(this.dataset.sofaMin, 10) || 60;
      const max = parseInt(this.dataset.sofaMax, 10) || 320;
      this.sofaW = parseInt(this.get('kirane:sofa'), 10) || parseInt(this.dataset.sofaDefault, 10) || 200;
      this.sofaW = Math.max(min, Math.min(max, this.sofaW));
      if (this.range) {
        this.range.min = min; this.range.max = max; this.range.value = this.sofaW;
        this.range.addEventListener('input', () => { this.sofaW = parseInt(this.range.value, 10); this.set('kirane:sofa', this.sofaW); this.paintSofa(); });
      }
      /* le curseur multicolore : une teinte continue le long de la gamme */
      const stored = parseInt(this.get('kirane:sofaPos'), 10);
      this.pos = isNaN(stored) ? Math.round((1 / (RANGE.length - 1)) * 1000) : Math.max(0, Math.min(1000, stored));
      this.colour = rangeAt(this.pos / 1000);
      if (this.hue) {
        this.hue.style.background = 'linear-gradient(to right,' + RANGE.join(',') + ')';
        this.hue.min = 0; this.hue.max = 1000; this.hue.value = this.pos;
        this.hue.style.setProperty('--c', this.colour);
        this.hue.addEventListener('input', () => {
          this.pos = parseInt(this.hue.value, 10);
          this.colour = rangeAt(this.pos / 1000);
          this.hue.style.setProperty('--c', this.colour);
          this.set('kirane:sofaPos', this.pos);
          this.paintSofa();
        });
      }
      if (this.btn) this.btn.addEventListener('click', () => this.submit());
      this.querySelectorAll('[data-look]').forEach((el) => {
        let list = [];
        const data = el.querySelector('script[type="application/json"]');
        try { list = JSON.parse(data.textContent).map(normalise); } catch (e) { list = []; }
        el.addEventListener('click', () => this.pose(list));
      });

      this.render();
      fetch(this.dataset.productsJson, { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((j) => {
          this.products = (j.products || []).filter((p) => (p.variants || []).length).map(normalise)
            .filter((p) => p.minPrice >= (cfg.minPrice || 0));
          this.classList.add('is-ready');
          this.render();
        }).catch((e) => console.error(e));
    }

    get(k, test) { try { const v = localStorage.getItem(k); return !test || test(v) ? v : ''; } catch (e) { return ''; } }
    set(k, v) { try { localStorage.setItem(k, String(v)); } catch (e) { /* navigation privée */ } }

    reindex() { this.slots.forEach((s, i) => { s.index = i; }); }
    usedSizes() { return this.slots.map((s) => s.variant.size); }

    /* un trio : on pose ses housses, les plus grandes tailles d'abord */
    pose(list) {
      if (!list || !list.length) return;
      this.slots = [];
      const used = [];
      list.slice(0, MAX_SLOTS).forEach((p) => {
        const v = bestVariant(p, used);
        used.push(v.size);
        this.slots.push({ product: p, variant: v });
      });
      this.reindex();
      this.render();
      if (this.getBoundingClientRect().top < 0) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    openAdd() {
      if (!this.products.length || this.slots.length >= MAX_SLOTS) return;
      const sh = getSheet();
      sh.onRemove = null;
      sh.pick(this.products, this.usedSizes(), (p, v) => {
        this.slots.push({ product: p, variant: v });
        this.reindex(); this.render();
      });
    }
    openCushion(i) {
      const slot = this.slots[i];
      if (!slot) return;
      const sh = getSheet();
      sh.onRemove = () => { this.slots.splice(i, 1); this.reindex(); this.render(); };
      sh.detailOf(slot.product, slot.variant,
        (p, v) => { this.slots[i] = { product: p, variant: v, dx: slot.dx, front: slot.front }; this.reindex(); this.render(); },
        () => { sh.onRemove = null; sh.pick(this.products, this.usedSizes(), (p, v) => { this.slots[i] = { product: p, variant: v }; this.reindex(); this.render(); }); });
    }

    paintSofa() {
      if (!this.stage) return;
      this.stage.innerHTML = sofaSVG(this.uid, this.slots, this.sofaW, this.colour, this.slots.length < MAX_SLOTS);
      if (this.value) this.value.textContent = this.sofaW + ' cm';
      this.bindSofa();
    }
    bindSofa() {
      const svg = this.stage.querySelector('svg');
      if (!svg) return;
      const add = svg.querySelector('[data-add-here]');
      if (add) {
        add.addEventListener('click', () => this.openAdd());
        add.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.openAdd(); } });
      }
      const vb = svg.viewBox.baseVal;
      const ux = (e) => { const r = svg.getBoundingClientRect(); return vb.x + ((e.clientX - r.left) / r.width) * vb.width; };
      let drag = null;
      svg.querySelectorAll('[data-cushion]').forEach((g) => {
        const i = parseInt(g.dataset.cushion, 10);
        const base = g.getAttribute('transform') || '';
        g.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.openCushion(i); } });
        g.addEventListener('pointerdown', (e) => {
          drag = { g: g, i: i, x0: ux(e), moved: 0 };
          try { g.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        });
        g.addEventListener('pointermove', (e) => {
          if (!drag || drag.g !== g) return;
          const dx = ux(e) - drag.x0;
          drag.lastX = ux(e);
          drag.moved = Math.max(drag.moved, Math.abs(dx));
          if (drag.moved > 4) g.classList.add('is-dragging');
          g.setAttribute('transform', 'translate(' + dx + ' 0) ' + base);
        });
        const end = (e) => {
          if (!drag || drag.g !== g) return;
          const d = drag, x = (typeof d.lastX === 'number' ? d.lastX : ux(e));
          drag = null;
          g.classList.remove('is-dragging');
          /* un simple toucher ouvre la fiche ; un glissement déplace */
          if (d.moved <= 4) { this.openCushion(d.i); return; }
          const slot = this.slots[d.i];
          if (slot) { slot.dx = (slot.dx || 0) + (x - d.x0); slot.front = ++this.frontSeq; }
          this.paintSofa();
        };
        g.addEventListener('pointerup', end);
        g.addEventListener('pointercancel', end);
      });
    }

    render() {
      this.paintSofa();
      const pr = price(this.slots);
      if (this.say) this.say.hidden = pr.n > 0;
      if (this.note) {
        this.note.textContent = pr.offer && pr.n === 2 ? t('one_more', 'encore une housse, et la troisième est offerte')
          : (pr.free.length ? t('free_on', 'la moins chère est offerte') : '');
      }
      if (this.btn) {
        this.btn.disabled = pr.n === 0;
        const label = this.btn.querySelector('span');
        if (label && pr.n) label.textContent = t('add_cart', 'ajouter au panier');
        let tot = this.btn.querySelector('b');
        if (pr.n) { if (!tot) { tot = document.createElement('b'); this.btn.appendChild(tot); } tot.textContent = money(totalOf(this.slots, pr, this.insertsOn)); }
        else if (tot) tot.remove();
      }
    }

    submit() {
      const items = []; let soldout = null;
      const push = (id) => { const f = items.find((x) => x.id === id); if (f) f.quantity += 1; else items.push({ id: id, quantity: 1 }); };
      this.slots.forEach((s) => {
        if (!s.variant.available) { soldout = s.product.short; return; }
        push(s.variant.id);
        if (this.insertsOn) { const i = insertFor(s.variant.size); if (i && i.available !== false) push(i.id); }
      });
      const show = (m) => { if (this.err) { this.err.textContent = m; this.err.hidden = false; } };
      if (this.err) this.err.hidden = true;
      if (soldout) { show(t('soldout_in', 'épuisée : ') + soldout); return; }
      if (!items.length) return;
      this.btn.disabled = true;
      addToCart(items).catch((e) => show(e.message || 'Erreur')).finally(() => { this.btn.disabled = false; });
    }
  }

  if (!customElements.get('canape-studio')) customElements.define('canape-studio', CanapeStudio);
})();